import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoricoNotaFiscal } from '../../../../../interfaces/historico-paciente';
import { BrlPipe } from '../../../../../utils/brl.pipe';
import { notasRecentes } from '../../../../../utils/historico-paciente.util';

function hojeLocalIso(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

@Component({
  selector: 'app-hp-notas',
  standalone: true,
  imports: [CommonModule, BrlPipe],
  templateUrl: './hp-notas.component.html',
  styleUrl: './hp-notas.component.scss',
})
export class HpNotasComponent {
  @Input() notas: HistoricoNotaFiscal[] = [];
  mostrarAnteriores = false;

  private get janela() {
    return notasRecentes(this.notas ?? [], hojeLocalIso());
  }

  get qtAnteriores(): number {
    return this.janela.ocultas.length;
  }

  get exibidas(): HistoricoNotaFiscal[] {
    return this.mostrarAnteriores ? (this.notas ?? []) : this.janela.visiveis;
  }

  verNota(n: HistoricoNotaFiscal): void {
    if (n.urlNfs) window.open(n.urlNfs, '_blank', 'noopener');
  }
}
